/** @overridable */
export const features = {
    create: true,
    delete: true,
    edit: true,
    list: true,
    view: true,
};
